/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const contactUpdateBodyPriorityMax = 100;

export const contactUpdateBodyExpectedVersionExclusiveMin = 0;
export const contactUpdateBodyExpectedVersionMax = 9007199254740991;

export const ContactUpdateBody = zod.object({
  destination: zod.string().optional(),
  label: zod.string().optional(),
  priority: zod.int().min(1).max(contactUpdateBodyPriorityMax).optional(),
  smsEnabled: zod.boolean().optional(),
  voiceEnabled: zod.boolean().optional(),
  enabled: zod.boolean().optional(),
  expectedVersion: zod
    .int()
    .gt(contactUpdateBodyExpectedVersionExclusiveMin)
    .max(contactUpdateBodyExpectedVersionMax),
});

export type ContactUpdateBody = zod.input<typeof ContactUpdateBody>;
export type ContactUpdateBodyOutput = zod.output<typeof ContactUpdateBody>;
